import React from 'react';
import { Box } from '@mui/material';
import { useMutation } from 'react-query';
import axios, { endPoints } from 'api/request';
import throttle from 'lodash/throttle';
import { useRecoilState } from 'recoil';
import Select from 'components/select';
import { requestDetails } from 'pages/onboard-developers/store';
import HelpImg from 'pages/onboard-developers/components/helpImg';

const ApplicationCI = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [details, setDetails] = useRecoilState(requestDetails);
    const [value, setValue] = React.useState(details?.applicationCIDetails || null);
    const [ccInputValue, setCCInputValue] = React.useState(details?.applicationCI || '');
    const [options, setOptions] = React.useState([]);
    const bCiPostApi = useMutation((payload) => axios.post(`${endPoints.riServices.COMMON.businessCiDetails}`, payload));
    const setAppService = (applicationCI) => {
        setDetails({
            ...details,
            applicationCI: applicationCI?.label,
            applicationCIDetails: applicationCI,
        });
    };
    const resetOptions = () => {
        setOptions([]);
    };

    const fetch = React.useMemo(
        () =>
            throttle((inputValue) => {
                bCiPostApi?.mutate({
                    businessApplication: null,
                    applicationService: inputValue,
                });
            }, 1000),
        []
    );

    React.useEffect(() => {
        if (ccInputValue === '') {
            resetOptions();
        }
        if (ccInputValue && ccInputValue !== '' && ccInputValue?.length > 2) fetch(ccInputValue);
    }, [ccInputValue, fetch]);

    React.useEffect(() => {
        if (bCiPostApi?.isSuccess) {
            if (bCiPostApi?.data?.data?.applications) {
                const { applicationServices = [] } = bCiPostApi?.data?.data?.applications?.[0] || {};
                const combinedValue = applicationServices?.map((app) => ({ label: `${app.serviceName}`, value: `${app.serviceName}`, data: app }));
                setOptions(combinedValue);
            }
        }
    }, [bCiPostApi?.isSuccess]);

    React.useEffect(() => {
        resetOptions();
    }, []);

    React.useEffect(() => {
        if (value !== null && value?.label) {
            setAppService(value);
        }
    }, [value]);

    React.useEffect(() => {
        if (!details?.applicationCI && details?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [details?.applicationCI, details?.isTouched]);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Select
                key="application Name"
                label="Application CI*"
                loading={bCiPostApi?.isLoading}
                placeholder="Type to search"
                value={details?.applicationCIDetails || null}
                onInputChange={(event, newInputValue) => {
                    if (newInputValue && newInputValue !== '') setCCInputValue(newInputValue);
                }}
                onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                        setValue({
                            label: newValue,
                        });
                    } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setValue({
                            label: newValue.inputValue,
                        });
                    } else {
                        setValue(newValue);
                    }
                }}
                filterOptions={(x) => x}
                selectOnFocus
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={options}
                getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                        return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                        return option.inputValue;
                    }
                    // Regular option
                    return option.label;
                }}
                renderOption={(props, option) => (
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    <li {...props}>{option.label}</li>
                )}
                freeSolo
                isRequired={isTouched}
            />
            <HelpImg title="Type to Search Application ." />
        </Box>
    );
};

export default React.memo(ApplicationCI);
